import { FILTER_TYPE } from "utils/constants";
import { useEffect, useRef, useState } from "react";

export const TEST_RATE_COLUMNS_DATA = ({
  localRateMap,
  localRateMrpMap,
  manuallyEditedMap,
  manuallyEditedMrpMap,
  toggleSelectRow,
  toggleSelectAll,
  isEditable,
  selectedRows,
  editableRows,
  setEditableRows,
  data,
  rate,
  mrp,
  mrpPercentage,
  ratePercentage,
  isSuperFranchise,
  isFranchise,
  isSubFranchise,
  hasAppliedPercentageMap,
  mergedData,
  // error,
  // setError,
  localRateEditableMap,
  setLocalRateEditableMap,
}) => {
  const columns = [
    {
      Header: "S.No",
      accessor: "_index",
      disableSortBy: true,
    },
    {
      Header: "Id",
      accessor: "id",
      disableSortBy: true,
    },
    {
      Header: "Department",
      accessor: "lab_department_name",
      disableSortBy: true,
    },
    {
      Header: "Franchise Name",
      accessor: "franchise_name",
      disableSortBy: true,
    },
    {
      Header: "",
      accessor: "ppppp",
      disableSortBy: true,
    },
    // {
    //   Header: "MRP Rate",
    //   accessor: "mrp_rate",
    //   disableSortBy: true,
    //   Cell: ({ row }) => {
    //     const rowId = row.original.id;
    //     const [baseMrpRate] = useState(
    //       row.original.baseMrpRate || row.original.mrp_rate
    //     );

    //     const [localMrpRate, setLocalMrpRate] = useState(() => {
    //       return (
    //         localRateMrpMap.current[rowId] ?? row.original.mrp_rate.toString()
    //       );
    //     });
    //     const [errors, setErrors] = useState("");

    //     useEffect(() => {
    //       if (!row.original.baseMrpRate) {
    //         row.original.baseMrpRate = row.original.mrp_rate;
    //       }
    //     }, [row.original]);

    //     // useEffect(() => {
    //     //   const isEditable = editableRows[row.original.id];
    //     //   if (!isEditable) return;

    //     //   if (mrp) {
    //     //     const roundedRate = Math.ceil(mrp);
    //     //     setLocalRate(roundedRate.toString());
    //     //     row.original.mrp_rate = roundedRate;
    //     //     hasAppliedPercentageMap.current[row.original.id] = true;
    //     //   } else if (mrpPercentage) {
    //     //     if (!hasAppliedPercentageMap.current[row.original.id]) {
    //     //       const percentageIncrease = (baseMrpRate * mrpPercentage) / 100;
    //     //       const adjustedRate = Math.ceil(baseMrpRate + percentageIncrease);
    //     //       setLocalRate(adjustedRate.toString());
    //     //       row.original.mrp_rate = adjustedRate;
    //     //       hasAppliedPercentageMap.current[row.original.id] = true;
    //     //     }
    //     //   } else {
    //     //     const rounded = Math.ceil(baseMrpRate);
    //     //     setLocalRate(rounded.toString());
    //     //     row.original.mrp_rate = rounded;
    //     //     hasAppliedPercentageMap.current[row.original.id] = false;
    //     //   }
    //     // }, [mrp, mrpPercentage, editableRows, row.original.id, baseMrpRate]);

    //     useEffect(() => {
    //       const rowId = row.original.id;
    //       const isEditable = editableRows[rowId];

    //       if (!isEditable) {
    //         const resetRate = Math.ceil(baseMrpRate).toString();
    //         setLocalMrpRate(resetRate);
    //         localRateMrpMap.current[rowId] = resetRate;
    //         row.original.mrp_rate = Number(resetRate);
    //         hasAppliedPercentageMap.current[rowId] = false;
    //         row.original.error = false;
    //         setErrors("");
    //         return;
    //       }

    //       if (manuallyEditedMrpMap.current[rowId]) return;

    //       let newRate;

    //       if (mrp) {
    //         newRate = Math.ceil(mrp);
    //         hasAppliedPercentageMap.current[rowId] = true;
    //       } else if (mrpPercentage) {
    //         const previousRate = parseFloat(localMrpRate) || baseMrpRate;
    //         const percentageIncrease = (previousRate * mrpPercentage) / 100;
    //         newRate = Math.ceil(previousRate + percentageIncrease);
    //         hasAppliedPercentageMap.current[rowId] = true;
    //       } else {
    //         newRate = Math.ceil(baseMrpRate);
    //         hasAppliedPercentageMap.current[rowId] = false;
    //       }

    //       const newRateStr = newRate.toString();
    //       setLocalMrpRate(newRateStr);
    //       row.original.mrp_rate = newRate;
    //       localRateMrpMap.current[rowId] = newRateStr;
    //     }, [mrp, mrpPercentage, editableRows, row.original.id, baseMrpRate]);

    //     const handleMRPChange = (e) => {
    //       const value = e.target.value;
    //       setLocalMrpRate(value);

    //       if (value === "") {
    //         setErrors("MRP cannot be empty");
    //         row.original.error = true;
    //       } else {
    //         setErrors("");
    //         row.original.error = false;
    //         manuallyEditedMrpMap.current[row.original.id] = true;
    //       }
    //     };

    //     const handleBlur = () => {
    //       if (localMrpRate === "" || isNaN(Number(localMrpRate))) {
    //         return;
    //       }

    //       const numericValue = Number(localMrpRate);
    //       const rounded = Math.ceil(numericValue);
    //       row.original.mrp_rate = rounded;
    //       setLocalMrpRate(rounded.toString());
    //       row.original.error = false;
    //       setErrors("");
    //       manuallyEditedMrpMap.current[row.original.id] = true;
    //       localRateMrpMap.current[row.original.id] = rounded.toString();
    //     };

    //     return editableRows[row.original.id] &&
    //       !isSuperFranchise &&
    //       !isFranchise &&
    //       !isSubFranchise ? (
    //       <div className="d-flex flex-column">
    //         <input
    //           style={{ width: "100px", height: "25px", padding: "6px 12px" }}
    //           type="number"
    //           value={localMrpRate}
    //           onChange={handleMRPChange}
    //           onBlur={handleBlur}
    //           onFocus={(e) => e.target.select()}
    //         />
    //         {errors && (
    //           <label className="text-danger" style={{ fontSize: "12px" }}>
    //             {errors}
    //           </label>
    //         )}
    //       </div>
    //     ) : (
    //       localMrpRate
    //     );
    //   },
    // },
    // {
    //   Header: "Test Rate",
    //   accessor: "rate",
    //   disableSortBy: true,
    //   Cell: ({ row }) => {
    //     const rowId = row.original.id;
    //     const [errors, setErrors] = useState("");

    //     const [localRate, setLocalRate] = useState(() => {
    //       return localRateMap.current[rowId] ?? row.original.rate.toString();
    //     });

    //     const [baseRate] = useState(row.original.baseRate ?? row.original.rate);

    //     useEffect(() => {
    //       if (!row.original.baseRate) {
    //         row.original.baseRate = row.original.rate;
    //       }
    //     }, [row.original]);

    //     // useEffect(() => {
    //     //   const isEditable = editableRows[rowId];
    //     //   // if (!isEditable) return;

    //     //   if (isEditable) {
    //     //     let newRate;

    //     //     if (rate) {
    //     //       newRate = Math.ceil(rate);
    //     //     } else if (
    //     //       ratePercentage &&
    //     //       !hasAppliedPercentageMap.current[rowId]
    //     //     ) {
    //     //       const previousRate = baseRate;
    //     //       const percentageIncrease = (previousRate * ratePercentage) / 100;
    //     //       newRate = Math.ceil(previousRate + percentageIncrease);
    //     //       hasAppliedPercentageMap.current[rowId] = true;

    //     //       const newRateStr = newRate.toString();
    //     //       setLocalRate(newRateStr);
    //     //       row.original.rate = newRate;
    //     //       localRateMap.current[rowId] = newRateStr;
    //     //     } else {
    //     //       newRate = Math.ceil(baseRate);
    //     //       hasAppliedPercentageMap.current[rowId] = false;
    //     //     }
    //     //   } else {
    //     //     const resetRate = Math.ceil(baseRate).toString();
    //     //     setLocalRate(resetRate);
    //     //     localRateMap.current[rowId] = resetRate;
    //     //     row.original.rate = Number(resetRate);
    //     //     hasAppliedPercentageMap.current[rowId] = false;
    //     //   }
    //     // }, [rate, ratePercentage, editableRows, rowId, baseRate, localRate]);

    //     useEffect(() => {
    //       const isEditable = editableRows[rowId];

    //       if (!isEditable) {
    //         const resetRate = Math.ceil(baseRate).toString();
    //         setLocalRate(resetRate);
    //         localRateMap.current[rowId] = resetRate;
    //         row.original.rate = Number(resetRate);
    //         hasAppliedPercentageMap.current[rowId] = false;
    //         row.original.error = false;
    //         setErrors("");
    //         return;
    //       }

    //       // if (!isEditable) return;

    //       if (row.original.mrp_rate < rate) {
    //         row.original.error = true;
    //         setErrors("Please Enter Less Than MRP RATE");
    //       } else if (row.original.rates > rate) {
    //         row.original.error = true;
    //         setErrors("Please Enter More Than Rate");
    //       } else {
    //         row.original.error = false;
    //         setErrors("");
    //       }

    //       // const shouldForceRecalculate = ratePercentage && !rate;

    //       if (manuallyEditedMap.current[rowId]) return;

    //       let newRate;

    //       if (rate) {
    //         newRate = Math.ceil(rate);
    //       } else if (ratePercentage) {
    //         const previousRate = parseFloat(localRate) || baseRate;
    //         const percentageIncrease = (previousRate * ratePercentage) / 100;
    //         newRate = Math.ceil(previousRate + percentageIncrease);
    //       } else {
    //         newRate = Math.ceil(baseRate);
    //       }

    //       const newRateStr = newRate.toString();
    //       setLocalRate(newRateStr);
    //       row.original.rate = newRate;
    //       localRateMap.current[rowId] = newRateStr;
    //     }, [rate, ratePercentage, editableRows, rowId, baseRate]);

    //     // useEffect(() => {
    //     //   const isEditable = editableRows[rowId];
    //     //   if (!isEditable) return;

    //     //   let newRate;

    //     //   if (rate) {
    //     //     newRate = Math.ceil(rate);
    //     //     const newRateStr = newRate.toString();
    //     //     setLocalRate(newRateStr);
    //     //     row.original.rate = newRate;
    //     //     localRateMap.current[rowId] = newRateStr;
    //     //     hasAppliedPercentageMap.current[rowId] = true;
    //     //   } else if (ratePercentage) {
    //     //     const percentageIncrease = (baseRate * ratePercentage) / 100;
    //     //     newRate = Math.ceil(baseRate + percentageIncrease);
    //     //     const newRateStr = newRate.toString();
    //     //     setLocalRate(newRateStr);
    //     //     row.original.rate = newRate;
    //     //     localRateMap.current[rowId] = newRateStr;
    //     //     hasAppliedPercentageMap.current[rowId] = true;
    //     //   } else {
    //     //     newRate = Math.ceil(baseRate);
    //     //     const newRateStr = newRate.toString();
    //     //     setLocalRate(newRateStr);
    //     //     row.original.rate = newRate;
    //     //     localRateMap.current[rowId] = newRateStr;
    //     //     hasAppliedPercentageMap.current[rowId] = false;
    //     //   }
    //     // }, [rate, ratePercentage, editableRows, rowId, baseRate]);

    //     const handleRateChange = (e) => {
    //       const value = e.target.value;

    //       setLocalRate(value);
    //       localRateMap.current[rowId] = value;
    //       manuallyEditedMap.current[rowId] = true;

    //       if (value === "") {
    //         row.original.error = true;
    //         setErrors("Rate cannot be empty");
    //         return;
    //       }

    //       const numericValue = Number(value);
    //       if (isNaN(numericValue)) {
    //         row.original.error = true;
    //         setErrors("Invalid number");
    //         return;
    //       }

    //       if (row.original.mrp_rate < numericValue) {
    //         row.original.error = true;
    //         setErrors("Please Enter Less Than MRP RATE");
    //       } else if (row.original.rates > numericValue) {
    //         row.original.error = true;
    //         setErrors("Please Enter More Than Rate");
    //       } else {
    //         row.original.error = false;
    //         setErrors("");
    //       }
    //     };

    //     const handleBlur = () => {
    //       if (localRate === "" || isNaN(Number(localRate))) return;

    //       const rounded = Math.ceil(Number(localRate));
    //       row.original.rate = rounded;
    //       const roundedStr = rounded.toString();
    //       setLocalRate(roundedStr);
    //       localRateMap.current[rowId] = roundedStr;
    //     };

    //     return editableRows[rowId] ? (
    //       <div className="d-flex flex-column">
    //         <input
    //           style={{ width: "100px", height: "25px", padding: "6px 12px" }}
    //           type="number"
    //           value={localRate}
    //           onChange={handleRateChange}
    //           onBlur={handleBlur}
    //           onFocus={(e) => e.target.select()}
    //         />
    //         {errors && (
    //           <label className="text-danger" style={{ fontSize: "12px" }}>
    //             {errors}
    //           </label>
    //         )}
    //       </div>
    //     ) : (
    //       localRate
    //     );
    //   },
    // },
    // {
    //   Header: () => {
    //     const checkboxRef = useRef(null);

    //     const allVisibleEditableRowsSelected = mergedData.every(
    //       (row) =>
    //         selectedRows.includes(row.id) && editableRows[row.id] === true
    //     );

    //     const someSelected = mergedData.some((row) =>
    //       selectedRows.includes(row.id)
    //     );

    //     useEffect(() => {
    //       if (checkboxRef.current) {
    //         checkboxRef.current.indeterminate =
    //           someSelected && !allVisibleEditableRowsSelected;
    //       }
    //     }, [someSelected, allVisibleEditableRowsSelected]);

    //     return (
    //       <input
    //         ref={checkboxRef}
    //         type="checkbox"
    //         onChange={(e) => toggleSelectAll(e.target.checked)}
    //         checked={mergedData.length > 0 && allVisibleEditableRowsSelected}
    //       />
    //     );
    //   },
    //   accessor: "_select",
    //   disableSortBy: true,
    //   Cell: ({ row }) => (
    //     <input
    //       type="checkbox"
    //       onChange={() => toggleSelectRow(row.original.id)}
    //       checked={selectedRows.includes(row.original.id)}
    //     />
    //   ),
    // },
  ];
  if (isSuperFranchise == 1 || isFranchise == 1) {
    const testRateIndex = columns.findIndex(
      (column) => column.accessor === "rate"
    );

    if (testRateIndex !== -1) {
      columns.splice(testRateIndex, 0, {
        Header: "Rate",
        accessor: "rates",
        disableSortBy: true,
      });
    }
  }

  return columns;
};

export const INVESTIGATION_MANAGER_COLUMNS_DATA = ({
  deleteRow,
  showObservation,
  editInvestigationManager,
  filters,
  isSuperFranchise,
  isFranchiseEmployee,
  isSubFranchise,
  showInvestigationComment,
  showInvestigationInterpretation,
  showHelpMenu,
  openAddDelivaryDays,
  openAddSequence,
  openAddInvestigationNabl,
  openAddInvestigationObservationFormula,
  openAddInvestigationTemplate,
  ShowInvestigationSampleReport,
}) => [
  {
    Header: "S.No",
    accessor: "_index",
    disableSortBy: true,
  },
  {
    Header: "Id",
    accessor: "id",
    disableSortBy: true,
  },
  {
    Header: "Investigation Name",
    accessor: "investigation_name",
    disableSortBy: true,
  },
  {
    Header: "Investigation Code",
    accessor: "investigation_code",
    disableSortBy: true,
  },
  {
    Header: "Gender",
    accessor: "gender",
    disableSortBy: true,
  },
];

export const TEST_RATE_FORM_CONFIG = (rowData) => [
  {
    label: "Test Code",
    type: "input-text",
    name: "test_code",
    defaultValue: rowData?.test_code || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Test Name",
    type: "input-text",
    name: "test_name",
    defaultValue: rowData?.test_name || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Test Rate",
    type: "input-text",
    name: "rate",
    defaultValue: rowData?.rate || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Test MRP Rate",
    type: "input-text",
    name: "mrp_rate",
    defaultValue: rowData?.mrp_rate || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Zone",
    type: "select",
    name: "zone_id",
    defaultValue: rowData?.zone_id || "",
    options: [],
    validations: {
      required: true,
    },
  },
  {
    label: "Frachise Type",
    type: "select",
    name: "franchise_type",
    defaultValue: rowData?.franchise_id || "",
    options: [],
    validations: {
      required: true,
    },
  },
  {
    label: "Frachise",
    type: "select",
    name: "franchise_dropdown",
    defaultValue: rowData?.franchise_id || "",
    options: [],
    validations: {
      required: true,
    },
  },
  {
    label: "Investigation Name",
    type: "select",
    name: "investigation_name",
    defaultValue: rowData?.investigation_id || "",
    options: [],
    validations: {
      required: true,
    },
  },
];

export const OPTIONS = [{ key: "test_name", value: "Test Name" }];

export const STATUS_OPTIONS = [
  { key: true, value: "Active" },
  { key: false, value: "Inactive" },
];

export const BILLING_OPTIONS = [
  { key: "", value: "Select Billing Category" },
  { key: "Routine", value: "Routine" },
  { key: "Special", value: "Special" },
];
export const FILTER_DEFINITIONS = [
  {
    name: "is_active",
    type: FILTER_TYPE.SELECT,
    initialValue: STATUS_OPTIONS[0].key,
  },
  {
    name: "billing_category",
    type: FILTER_TYPE.SELECT,
    initialValue: BILLING_OPTIONS[0].key,
  },
];
